import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const BulletListIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "BulletList",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M28.68 6.39H12.91c-.73 0-1.32.59-1.32 1.32s.59 1.32 1.32 1.32h15.77c.73 0 1.32-.59 1.32-1.32s-.59-1.32-1.32-1.32m-15.77 7h8.76c.73 0 1.32-.59 1.32-1.32s-.59-1.32-1.32-1.32h-8.76c-.73 0-1.32.59-1.32 1.32s.59 1.32 1.32 1.32m8.76 12.24c.73 0 1.32-.59 1.32-1.32s-.59-1.32-1.32-1.32h-8.76c-.73 0-1.32.59-1.32 1.32s.59 1.32 1.32 1.32zm7.01-6.99H12.91c-.73 0-1.32.59-1.32 1.32s.59 1.32 1.32 1.32h15.77c.73 0 1.32-.59 1.32-1.32s-.59-1.32-1.32-1.32M8.98 9.86c0 1.93-1.56 3.49-3.49 3.49S2 11.79 2 9.86s1.56-3.49 3.49-3.49 3.49 1.56 3.49 3.49m0 12.27c0 1.93-1.56 3.49-3.49 3.49S2 24.06 2 22.13s1.56-3.49 3.49-3.49 3.49 1.56 3.49 3.49"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M28.14 7.14H14.43a1.14 1.14 0 1 1 0-2.28h13.71a1.14 1.14 0 1 1 0 2.28M21.29 12.86h-6.86a1.14 1.14 0 1 1 0-2.28h6.86a1.14 1.14 0 1 1 0 2.28M28.14 22H14.43a1.14 1.14 0 1 1 0-2.28h13.71a1.14 1.14 0 1 1 0 2.28M21.29 27.71h-6.86a1.14 1.14 0 1 1 0-2.28h6.86a1.14 1.14 0 1 1 0 2.28"
      }), /*#__PURE__*/_jsx("circle", {
        cx: "5.86",
        cy: "8.86",
        r: "2.86"
      }), /*#__PURE__*/_jsx("path", {
        d: "M5.86 12.86c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4m0-5.72a1.71 1.71 0 1 0-.002 3.418A1.71 1.71 0 0 0 5.86 7.14"
      }), /*#__PURE__*/_jsx("circle", {
        cx: "5.86",
        cy: "23.72",
        r: "2.86"
      }), /*#__PURE__*/_jsx("path", {
        d: "M5.86 27.71c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4m0-5.71a1.71 1.71 0 1 0-.002 3.418A1.71 1.71 0 0 0 5.86 22"
      })]
    })
  }));
};